import { useSyncExternalStore } from 'react'
import { fmtDateTime, timeAgo } from '../common'
import { useFrescura } from './useFrescura'
import './netchip.css'

// Chip de "sin conexión". Solo aparece cuando NO hay red: online es el estado normal
// y no merece pixeles. Se apoya en navigator.onLine, que miente hacia el lado
// optimista (dice true con wifi sin salida) pero nunca hacia el pesimista: si dice
// false, seguro no hay red. Los errores reales de fetch los cubre apiFetch.

function subscribe(cb: () => void) {
  window.addEventListener('online', cb)
  window.addEventListener('offline', cb)
  return () => {
    window.removeEventListener('online', cb)
    window.removeEventListener('offline', cb)
  }
}

export function useOnline(): boolean {
  return useSyncExternalStore(
    subscribe,
    () => navigator.onLine,
    () => true,
  )
}

// De cuándo son los datos. Tres escalones a propósito:
//  · menos de 10 min → no se dice la hora: sería ruido y suena a alarma.
//  · menos de 24 h  → RELATIVO ("hace 2 h"). Es una resta entre dos lecturas del
//    MISMO reloj, así que es inmune a que el reloj del teléfono esté mal. La fecha
//    absoluta ahí mentiría.
//  · 24 h o más → absoluto, porque "hace 9 d" ya no ubica a nadie.
export function coletilla(at: number): string {
  if (!at) return 'estás viendo lo último que se descargó'
  const edad = Date.now() - at
  if (edad < 10 * 60_000) return 'estás viendo lo último que se descargó'
  const iso = new Date(at).toISOString()
  return edad < 24 * 3_600_000
    ? `información de ${timeAgo(iso)}`
    : `información del ${fmtDateTime(iso)}`
}

export function NetChip() {
  const online = useOnline()
  const at = useFrescura()
  if (online) return null
  return (
    <div className="net-chip" role="status" aria-live="polite">
      <span className="net-dot" aria-hidden="true" />
      Sin conexión · {coletilla(at)}
    </div>
  )
}
